import { ListFilter } from "lucide-react";
import React from "react";
import { Button } from "../../Button";
import { IFilterButtonProps } from "../types";

const FilterButton: React.FC<IFilterButtonProps> = ({
    selectedFiltersCount,
    title = selectedFiltersCount ? `(${selectedFiltersCount})` : "",
    trackName,
    onClick
}) => {
    return <Button icon={<ListFilter />} onClick={onClick} title={title} trackName={trackName} variant="secondary" />;
};

export default FilterButton;
